import 'styles/BugReportDevViewPage.css';

import BugReportList from 'components/BugReportList';

import { useQuery } from '@apollo/client';
import { ALL_BUG_REPORTS_QUERY } from 'graphql/APICalls';

export default function BugReportDevViewPage() {

  const { data: bugReportsData } = useQuery(ALL_BUG_REPORTS_QUERY);

  return (
    <div className="auto-scrollbar">
      <div className="centerer activity-page-overlay">
        <div className="centered bug-report-dev-view-container">

          <div className="card">
            <h3>All bug reports</h3>
            <BugReportList bugReports={bugReportsData?.allBugReports} showCreator={true} noReportsMessage="There are no reports yet." />
          </div>

        </div>
      </div>
    </div>
    );
}